import Vue from 'vue';
import Vuex from 'vuex';
import designgroups from './modules/admin/designgroups';
import cards from './modules/cards';
import config from './modules/config';
import designer from './modules/designer';
import designrequests from './modules/designrequests';
import drawers from './modules/drawers';
import lookups from './modules/lookups';
import messages from './modules/messages';
import orders from './modules/orders';
import printcart from './modules/printcart';
import projects from './modules/projects';
import promo from './modules/promo';
import subscription from './modules/subscription';
import teams from './modules/teams';
import templates from './modules/templates';
import tools from './modules/tools';
import user from './modules/user';
import userCollections from './modules/userCollections';
// contributor stores
import contributorCustomerProjects from './modules/contributor/customerProjects';
// admin stores
import attributes from './modules/admin/attributes';
import collections from './modules/admin/collections';
import companies from './modules/admin/companies';
import adminOrders from './modules/admin/orders';
import productSetup from './modules/admin/productSetup';
import promocodes from './modules/admin/promocodes';
import users from './modules/admin/users';
// snailblast stores
import campaign from './modules/snailblast/campaign';
import sbLookup from './modules/snailblast/lookup';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    admin: {
      namespaced: true,
      modules: {
        attributes: attributes,
        collections: collections,
        companies: companies,
        users: users,
        designgroups: designgroups,
        productSetup: productSetup,
        promocodes: promocodes,
        orders: adminOrders
      }
    },
    contributor: {
      namespaced: true,
      modules: {
        customerProjects: contributorCustomerProjects
      }
    },
    snailblast: {
      namespaced: true,
      modules: {
        campaign: campaign,
        lookup: sbLookup
      }
    },
    cards,
    config,
    designer,
    designrequests,
    drawers,
    lookups,
    messages,
    orders,
    printcart,
    projects,
    promo,
    subscription,
    templates,
    teams,
    tools,
    user,
    userCollections
  }
});
